<!--
 * @Description: 多语言切换下拉框['EN', 'CN']
 * @Author: hedongyang
 * @Date: 2023-07-28
 * @LastEditTime: 2024-02-04 19:32:15
 * @LastEditors: Please set LastEditors
 * @Reference:
-->
<script setup>
// import { ref, computed } from 'vue';
import useVueI18n from '../hook';
defineOptions({
  name: 'YlI18nSelect'
});
const langType = localStorage.getItem('lang') || 'CN';
const { langList, radioChange } = useVueI18n();
// console.log('langlanglang I18nRadio', langList, langList.value); // 'hello'
</script>

<template>
  <div class="i18n-select">
    <el-select
      v-model="langType"
      class=""
      popper-class=""
      :popper-append-to-body="false"
      @change="radioChange"
    >
      <el-option
        v-for="item in langList"
        :key="item.val"
        :value="item.val"
        :label="item.local"
      />
    </el-select>
  </div>
</template>
<style lang="scss">
.i18n-select {
}
</style>../hook
